export default "__VITE_ASSET__Cy3RpJ34__"